import { formatNearAmount } from 'near-api-js/lib/utils/format';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Result = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  try {
    const { quizId } = location?.state;
  } catch (error) {
    return (
      <main className='py-12 flex flex-col gap-6 items-center justify-center min-h-[70vh]'>
        <h1 className='text-3xl font-bold'>{t('result-error')}</h1>
      </main>
    );
  }

  const {
    quizId,
    quizTitle,
    quizDescription,
    resultInPercent,
    questionsLength,
    isRewardGiven,
    rewardPerWinner,
    remainingReward,
    percentageToWin,
    resp,
    isRewarded,
  } = location?.state;

  const score = Math.ceil((resultInPercent * questionsLength) / 100);

  const handleErrorMsg = (err) => {
    if (err.includes('not allowed'))
      return i18n.language === 'en'
        ? 'You are not allowed to access this quiz'
        : 'غير مسموح لك بالوصول إلى هذا الاختبار';
    else if (err.includes('not started'))
      return i18n.language === 'en'
        ? 'This quiz has not started yet'
        : 'لم يبدأ هذا الاختبار بعد';
    else if (err.includes('expired'))
      return i18n.language === 'en'
        ? 'This quiz has expired'
        : 'انتهت صلاحية هذا الاختبار';
    else if (err.includes('already taken'))
      return i18n.language === 'en'
        ? "You've already taken this quiz"
        : 'لقد أجبت على هذا الاختبار بالفعل';
    else {
      console.log(err);
      return err.split(':')[1].split(',')[0];
    }
  };

  return (
    <main className='py-12 flex flex-col gap-6 items-center justify-center min-h-[70vh]'>
      {isRewardGiven && (
        <h3
          dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
          className='bg-primary-600 text-white px-4 py-3 rounded-xl max-w-fit mx-auto'>
          <span className='font-bold text-2xl'>{t('result-congrats')}</span>{' '}
          <br /> {t('result-congrats-sub-a')}{' '}
          {formatNearAmount(rewardPerWinner)} {t('result-congrats-sub-b')}
        </h3>
      )}
      <h1 className='text-3xl font-bold'>{quizTitle}</h1>
      {quizDescription && (
        <h3 className='text-xl font-semibold'>{quizDescription}</h3>
      )}
      {resp.status === 'error' ? (
        <>
          <h2 className='text-2xl font-bold text-red-500 max-w-3xl mx-auto'>
            {/* {resp.msg.toUpperCase()} */}
            {handleErrorMsg(resp.msg)}
          </h2>
        </>
      ) : (
        <>
          {(score / questionsLength) * 100 >= percentageToWin ? (
            <div
              className='border border-primary-600 rounded-xl p-3'
              dir={i18n.language === 'en' ? 'ltr' : 'rtl'}>
              <h2 className='uppercase text-primary-500 mb-2 font-bold text-2xl'>
                {i18n.language === 'en' ? 'Congratulations' : 'تهانينا'}
              </h2>
              <h3>
                {i18n.language === 'en'
                  ? `You got ${((score / questionsLength) * 100).toFixed(
                      2
                    )}%, which is more than or equal
                the required ${percentageToWin}%.`
                  : `لقد حصلت على ${((score / questionsLength) * 100).toFixed(
                      2
                    )}% ، وهو أكثر من أو يساوي
                النسبة المطلوبة ${percentageToWin}%`}
              </h3>
              {!isRewardGiven && (
                <div className='mt-2'>
                  {i18n.language === 'en' ? (
                    <>
                      However,
                      {isRewarded ? (
                        <h4>
                          It seems that you've received your reward before
                        </h4>
                      ) : (
                        <h4>There is no more rewards left</h4>
                      )}
                    </>
                  ) : (
                    <>
                      ولكن،
                      {isRewarded ? (
                        <h4>يبدو أنك حصلت على مكافأتك من قبل</h4>
                      ) : (
                        <h4>لم يتبق بعد أي مكافآت</h4>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className='border border-primary-600 rounded-xl p-3'>
              {i18n.language === 'en' ? (
                <>
                  <h2 className='uppercase text-primary-500 mb-2'>Failed</h2>
                  <h3>
                    You got {((score / questionsLength) * 100).toFixed(2)}%,
                    which is less than the required {percentageToWin}% to pass
                    this quiz.
                  </h3>
                </>
              ) : (
                <>
                  <h2 className='uppercase text-primary-500 mb-2'>لم تنجح</h2>
                  <h3>
                    لقد حصلت على {((score / questionsLength) * 100).toFixed(2)}%
                    ، وهو أقل من النسبة المطلوبة {percentageToWin}% للنجاح في
                    هذا الاختبار.
                  </h3>
                </>
              )}
            </div>
          )}
          <h3 className='text-xl font-semibold'>
            {t('result-you-got')} {score} {''}
            {t('result-out-of')} {questionsLength} {t('result-correct')}
          </h3>
          <a
            href={
              i18n.language === 'en'
                ? `https://api.whatsapp.com/send?text=Hi!%0AI%20just%20got%20${score}%20out%20of%20${questionsLength}%20in%20the%20*${quizTitle}*%20Quiz%0A%0AWhat%20about%20you%3F%0A%0ATry%20it%20here%3A%20${window.location.origin}/quiz/${quizId}`
                : `https://api.whatsapp.com/send?text=%D8%A3%D9%87%D9%84%D9%8B%D8%A7%21%0A%D9%84%D9%82%D8%AF%20%D8%AD%D8%B5%D9%84%D8%AA%20%D8%B9%D9%84%D9%89%20${score}%20%D9%85%D9%86%20${questionsLength}%20%D9%81%D9%8A%20%D8%A7%D8%AE%D8%AA%D8%A8%D8%A7%D8%B1%20${quizTitle}%0A%D9%85%D8%A7%D8%B0%D8%A7%20%D8%B9%D9%86%D9%83%D8%9F%0A%D9%84%D9%84%D8%AF%D8%AE%D9%88%D9%84%20%D9%84%D9%84%D8%A7%D8%AE%D8%AA%D8%A8%D8%A7%D8%B1%3A%20${window.location.origin}/quiz/${quizId}`
            }
            target='_blank'
            rel='noreferrer'
            className='relative p-4 overflow-hidden font-medium rounded-lg group bg-gradient-to-br from-primary-400 to-primary-600 group-hover:from-primary-400 group-hover:to-primary-600 hover:text-white text-white focus:ring-4 focus:outline-none focus:ring-primary-200 dark:focus:ring-primary-700'>
            {t('result-share')}
          </a>
        </>
      )}
    </main>
  );
};

export default Result;
